import { useTweak } from '@/lib/feature-flags';
import { fonctionLetterClass } from '@/lib/noyaux';
import type { FonctionCode } from '@/schemas/word';

interface FunctionLetterProps {
  fonction: FonctionCode | null;
  /**
   * Render a zero-width `words-res-fn--empty` placeholder when `fonction` is
   * null, so list-row layouts stay aligned. Detail-page usage omits the badge
   * entirely instead (the default).
   */
  placeholder?: boolean;
}

/**
 * The single coloured function letter (G/P/S) shown next to a word's title.
 * Two styles, toggleable via the `function_letter_style` dev tweak:
 * `chip` (default) — deep letter on a light-tint disc; `bare` — the glyph
 * itself filled with the pale tint colour, no disc.
 */
export function FunctionLetter({ fonction, placeholder = false }: FunctionLetterProps) {
  const bare = useTweak('function_letter_style') === 'bare';

  if (!fonction) {
    return placeholder ? <span className="words-res-fn words-res-fn--empty" /> : null;
  }

  return (
    <span
      className={`words-res-fn ${fonctionLetterClass(fonction)}${bare ? ' words-res-fn--bare' : ''}`}
      title={fonction}
    >
      {fonction}
    </span>
  );
}
